/* Roomberry Pilzlicht-Set — Seitenlogik.
 *
 * Aufgabe: Ersparnis, Einzelpreise, Setpreis, Kurzname, Artikelnummer, Bild der
 * Schwebeleiste und die Auswahl-Marker an die gewählte Variante binden.
 *
 * Alle Zahlen kommen aus der JSON-Insel script[data-rb-pilzlicht-preise], die
 * snippets/rb-pilzlicht-rechnen.liquid aus den LIVE-Preisen der vier
 * Komponentenprodukte baut. In dieser Datei steht keine Zahl, und sie rechnet
 * auch nicht: sie schreibt nur ab. Fehlt die Insel oder steht ok:false, bleibt
 * die Anzeigestelle leer statt falsch.
 *
 * Keine externe Abhängigkeit, kein jQuery, kein Zugriff auf lazysizes.
 * Der Warenkorb, die Variantenwahl und der Preis bleiben komplett beim Theme:
 * wir setzen nur den vorhandenen Radio/Select und lassen das Theme reagieren.
 * Der Kaufknopf der Schwebeleiste klickt den echten Kaufknopf — kein zweites
 * Produktformular, das die falsche Variante senden könnte.
 */
(function () {
  'use strict';
  if (window.RBPilzlicht) { return; }

  var daten = null;
  var index = null;

  function lade() {
    if (daten) { return daten; }
    var el = document.querySelector('script[data-rb-pilzlicht-preise]');
    if (!el) { return null; }
    try { daten = JSON.parse(el.textContent); } catch (e) { daten = null; }
    if (daten && daten.varianten) {
      index = {};
      daten.varianten.forEach(function (v) { index[v.set + '||' + v.farbe] = v; });
    }
    return daten;
  }

  function alle(wahl, wurzel) {
    return Array.prototype.slice.call((wurzel || document).querySelectorAll(wahl));
  }

  /* Aktueller Wert einer Produktoption aus dem Varianten-Wähler des Themes. */
  function wertVon(optionsname) {
    if (!optionsname) { return ''; }
    var sichere = optionsname.replace(/"/g, '\\"');
    var radio = document.querySelector('input.product-variant-radio[name="' + sichere + '"]:checked');
    if (radio) { return radio.value; }
    var auswahl = document.querySelector('select.product-variant-select[name="' + sichere + '"]');
    if (auswahl) { return auswahl.value; }
    return '';
  }

  /* Optionswert setzen — das Theme hängt an denselben Elementen und
     aktualisiert danach Preis, Varianten-ID und Galerie selbst. */
  function setzeWert(optionsname, wert) {
    if (!optionsname || !wert) { return false; }
    var sichere = optionsname.replace(/"/g, '\\"');
    var radios = alle('input.product-variant-radio[name="' + sichere + '"]');
    for (var i = 0; i < radios.length; i += 1) {
      if (radios[i].value === wert) {
        if (!radios[i].checked) {
          /* Das Theme hängt seinen Handler an die Hülle
             .product-information-variant-picker-button-variant-option, nicht an
             das Radio. Ein Klick auf das nackte Radio setzt zwar checked, lässt
             Preis, Varianten-ID und Galerie aber stehen. */
          var huelle = radios[i].closest
            ? radios[i].closest('.product-information-variant-picker-button-variant-option')
            : null;
          if (huelle) { huelle.click(); } else { radios[i].click(); }
        }
        return true;
      }
    }
    var auswahl = document.querySelector('select.product-variant-select[name="' + sichere + '"]');
    if (auswahl) {
      for (var j = 0; j < auswahl.options.length; j += 1) {
        if (auswahl.options[j].value === wert) {
          auswahl.selectedIndex = j;
          auswahl.dispatchEvent(new Event('change', { bubbles: true }));
          return true;
        }
      }
    }
    return false;
  }

  function enthaelt(text, stichwort) {
    if (!stichwort) { return true; }
    if (!text) { return false; }
    return text.toLowerCase().indexOf(stichwort.toLowerCase()) !== -1;
  }

  function setWert() {
    var d = lade();
    if (!d) { return ''; }
    return wertVon(d.setOption) || d.setStart || '';
  }

  function farbWert() {
    var d = lade();
    if (!d) { return ''; }
    return wertVon(d.farbOption) || d.farbStart || '';
  }

  function ausIndex(set, farbe) {
    if (!index) { return null; }
    return index[set + '||' + farbe] || null;
  }

  function aktuell() {
    return ausIndex(setWert(), farbWert());
  }

  /* Der Satz wird aus den Einzelwerten zusammengesetzt, nicht aus einem
     fertigen String zurückgeparst. Damit hängt nichts am Geldformat des Shops.
     Kein innerHTML aus Daten — alles bleibt Text. */
  function schreibeSatz(el, e) {
    while (el.firstChild) { el.removeChild(el.firstChild); }
    if (!e || !e.ok) { return; }
    el.appendChild(document.createTextNode('Einzeln ' + e.einzeln + ' — im Set ' + e.preis + '. Du sparst '));
    var b = document.createElement('b');
    b.className = 'rb-pl-ersparnis__spar rb-pl__zahl';
    b.appendChild(document.createTextNode(e.spart));
    el.appendChild(b);
    el.appendChild(document.createTextNode('.'));
  }

  function satzAus(e) {
    if (!e || !e.ok) { return ''; }
    return 'Einzeln ' + e.einzeln + ' — im Set ' + e.preis + '. Du sparst ' + e.spart + '.';
  }

  function findePosten(positionen, praefix) {
    if (!positionen) { return null; }
    for (var i = 0; i < positionen.length; i += 1) {
      if (positionen[i].praefix === praefix) { return positionen[i]; }
    }
    return null;
  }

  function zeichnePosten(el, positionen) {
    while (el.firstChild) { el.removeChild(el.firstChild); }
    (positionen || []).forEach(function (p) {
      var li = document.createElement('li');
      var links = document.createElement('span');
      links.appendChild(document.createTextNode(p.name));
      var rechts = document.createElement('b');
      rechts.className = 'rb-pl__zahl';
      rechts.appendChild(document.createTextNode(p.preis));
      li.appendChild(links);
      li.appendChild(rechts);
      el.appendChild(li);
    });
  }

  function setzeText(wahl, wert) {
    alle(wahl).forEach(function (el) { el.textContent = wert; });
  }

  function zeichne() {
    var d = lade();
    if (!d) { return; }

    var set = setWert();
    var farbe = farbWert();
    var e = aktuell();

    setzeText('[data-rb-setname]', set);
    setzeText('[data-rb-farbname]', farbe);

    /* Zeilen, die nur zu bestimmten Lampen gehören. Die Stichwörter stehen
       wörtlich im Set-Optionswert (Vertrag, SPEC § 6.3). */
    alle('[data-rb-lampe]').forEach(function (el) {
      var drin = enthaelt(set, el.getAttribute('data-rb-lampe'));
      if (el.hasAttribute('data-rb-ausblenden')) {
        el.hidden = !drin;
      } else {
        el.setAttribute('data-rb-aus', drin ? 'false' : 'true');
        var haken = el.querySelector('.rb-pl-paket__haken');
        if (haken) { haken.textContent = drin ? '✓' : '+'; }
      }
    });

    /* Beide Schreibweisen: `data-rb-set-waehlen` ist die neue, der SPEC-Vertrag
       nennt weiterhin `data-rb-licht-waehlen`. Beide zeigen auf denselben Wert. */
    alle('[data-rb-set-waehlen],[data-rb-licht-waehlen]').forEach(function (el) {
      var w = el.getAttribute('data-rb-set-waehlen') || el.getAttribute('data-rb-licht-waehlen');
      el.setAttribute('aria-pressed', w === set ? 'true' : 'false');
    });
    alle('[data-rb-farbe-waehlen]').forEach(function (el) {
      el.setAttribute('aria-pressed', el.getAttribute('data-rb-farbe-waehlen') === farbe ? 'true' : 'false');
    });

    /* Die Stufenkarten folgen der Farbe, auch wenn sie nicht die aktive Stufe sind. */
    alle('[data-rb-stufensatz]').forEach(function (el) {
      var x = ausIndex(el.getAttribute('data-rb-stufensatz'), farbe);
      while (el.firstChild) { el.removeChild(el.firstChild); }
      if (x && x.ok) {
        var spar = document.createElement('b');
        spar.className = 'rb-pl-leiter__spar rb-pl__zahl';
        spar.appendChild(document.createTextNode('Du sparst ' + x.spart));
        var bezug = document.createElement('span');
        bezug.className = 'rb-pl-leiter__bezug rb-pl__zahl';
        bezug.appendChild(document.createTextNode('einzeln ' + x.einzeln + ' \u00b7 im Set ' + x.preis));
        el.appendChild(spar);
        el.appendChild(bezug);
      }
    });

    /* Der Marker folgt der echten Auswahl (Befund B21). Vorher klebte
       „vorausgewählt" fest auf der dritten Karte, während die erste gewählt war —
       bei 70 € Unterschied behaupteten zwei Geldzahlen gleichzeitig, die gewählte
       zu sein. `still` ist der unveränderliche Marker der Karte („größte
       Ersparnis"), er kommt zurück, sobald die Karte nicht mehr gewählt ist. */
    alle('[data-rb-marker]').forEach(function (el) {
      var karte = el.closest ? el.closest('[data-rb-set-waehlen],[data-rb-licht-waehlen]') : null;
      var wert = karte
        ? (karte.getAttribute('data-rb-set-waehlen') || karte.getAttribute('data-rb-licht-waehlen'))
        : '';
      var aktivText = el.getAttribute('data-rb-marker-aktiv') || '';
      var still = el.getAttribute('data-rb-marker-still') || '';
      var istAktiv = !!(wert && wert === set && aktivText);
      var text = istAktiv ? aktivText : still;
      el.textContent = text || '\u00a0';
      if (el.classList) {
        el.classList.toggle('rb-pl__marker--leer', !text);
        el.classList.toggle('rb-pl__marker--aktiv', istAktiv);
      }
    });

    /* Welche Lampen wirklich in dieser Variante liegen (Befund B27). Steht vor der
       ok-Wache: die Aussage ist eine Inhaltsangabe, keine Geldzahl. */
    if (e && e.licht) { setzeText('[data-rb-lichtzeile]', e.licht); }

    /* Nur-Set-Farben (Nachbesserung 10.10.2026, Benjamins Entscheid 24.09.): in Gelb/Grün
       und Blau/Schwarz gibt es vier der fünf Regale nicht einzeln, als Einzelpreis steht
       die SKU in Weiß. Die Insel sagt je Variante, ob das zutrifft (nurset), welche Farbe
       die Preisquelle ist (nursetQuelle) und welche Regale betroffen sind (nursetPraefixe).
       Hinweiszeilen [data-rb-nurset] ein-/ausblenden, Farbwörter nachführen, Kachel-Hinweis
       je Regal schalten. Steht vor der ok-Wache: Inhaltsangabe, keine Geldzahl. */
    var nurSet = !!(e && e.nurset);
    alle('[data-rb-nurset]').forEach(function (el) { el.hidden = !nurSet; });
    if (e) {
      setzeText('[data-rb-nurset-farbe]', e.farbe || '');
      setzeText('[data-rb-nurset-quelle]', e.nursetQuelle || '');
    }
    alle('[data-rb-nurset-kachel]').forEach(function (el) {
      var p = el.getAttribute('data-rb-nurset-kachel');
      var liste = (e && e.nursetPraefixe) || [];
      el.hidden = !(nurSet && liste.indexOf(p) !== -1);
    });

    /* Ab hier nur, wenn die Rechnung für die gewählte Variante trägt.
       Sonst bleibt stehen, was serverseitig gerendert wurde — nie eine Null. */
    alle('[data-rb-panel]').forEach(function (el) { el.hidden = !(e && e.ok); });
    alle('[data-rb-sparwrap]').forEach(function (el) { el.hidden = !(e && e.ok); });
    if (!e || !e.ok) { return; }

    setzeText('[data-rb-spar]', e.spart);
    setzeText('[data-rb-einzeln]', e.einzeln);
    setzeText('[data-rb-setpreis]', e.preis);
    setzeText('[data-rb-prozent]', e.prozent + ' %');
    setzeText('[data-rb-kurzname]', e.kurz);
    setzeText('[data-rb-sku]', e.sku);

    alle('[data-rb-stickybild]').forEach(function (el) { if (e.bild) { el.src = e.bild; } });
    alle('[data-rb-posten]').forEach(function (el) { zeichnePosten(el, e.positionen); });
    alle('[data-rb-ersparnis]').forEach(function (el) { schreibeSatz(el, e); });

    alle('[data-rb-stapelpreis]').forEach(function (el) {
      var p = findePosten(e.positionen, el.getAttribute('data-rb-stapelpreis'));
      var zeile = el.closest ? el.closest('.rb-pl-stapel__zeile') : null;
      if (p) {
        el.textContent = p.preis;
        if (zeile) { zeile.hidden = false; }
      } else {
        el.textContent = '';
        if (zeile) { zeile.hidden = true; }
      }
    });
  }

  function kaufen() {
    var knopf = document.querySelector('.product-information-buy-buttons button[type="submit"]')
      || document.querySelector('form[action*="/cart/add"] button[type="submit"]');
    if (knopf) { knopf.click(); return true; }
    return false;
  }

  function klick(ev) {
    var ziel = ev.target.closest
      ? ev.target.closest('[data-rb-kaufen],[data-rb-set-waehlen],[data-rb-licht-waehlen],[data-rb-farbe-waehlen],[data-rb-springen]')
      : null;
    if (!ziel) { return; }

    if (ziel.hasAttribute('data-rb-kaufen')) {
      /* Alle Kaufknöpfe der Seite ([data-rb-kaufen], document-weit) bedient rb-lsp.js
         (Sektion rb_sticky, Wache window.RBLsp). Ein zweiter Handler hier hieße zwei
         Submits je Klick — Vorschau 10.10.2026: Pilze-, FAQ- und Kaufband-Knopf je
         2× submit + 2× /cart/add.js, live wäre das Menge 2 im Warenkorb. Die frühere
         Ausnahme nur für .rb-lsp-sticky ließ die Gegenrichtung doppelt. Dieser Zweig
         springt nur noch ein, wenn rb-lsp.js auf der Seite fehlt. */
      if (window.RBLsp) { return; }
      ev.preventDefault();
      if (!kaufen()) {
        var box = document.querySelector('.product-information-buy-buttons');
        if (box) { box.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
      }
      return;
    }

    var sprung = ziel.getAttribute('data-rb-springen');
    if (sprung) {
      var knoten = document.querySelector(sprung);
      if (knoten) { ev.preventDefault(); knoten.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      return;
    }

    var d = lade();
    if (!d) { return; }
    var s = ziel.getAttribute('data-rb-set-waehlen') || ziel.getAttribute('data-rb-licht-waehlen');
    if (s) { setzeWert(d.setOption, s); }
    var f = ziel.getAttribute('data-rb-farbe-waehlen');
    if (f) { setzeWert(d.farbOption, f); }
    window.setTimeout(zeichne, 60);
  }

  /* Die Schwebeleiste erscheint erst, wenn der echte Kaufknopf aus dem Bild
     ist — nicht ab dem ersten Scrollpixel. Sonst verdeckt sie Inhalt neben
     einem sichtbaren Kaufknopf. */
  function schwebeleiste() {
    alle('[data-rb-sticky]').forEach(function (leiste) {
      if (leiste.getAttribute('data-rb-sticky-bereit') === 'ja') { return; }
      leiste.setAttribute('data-rb-sticky-bereit', 'ja');
      var wahl = leiste.getAttribute('data-rb-ab') || '.product-information-buy-buttons';
      var anker = document.querySelector(wahl);
      if (!anker || !window.IntersectionObserver) { return; }
      var beobachter = new IntersectionObserver(function (eintraege) {
        eintraege.forEach(function (eintrag) {
          leiste.hidden = eintrag.isIntersecting || eintrag.boundingClientRect.top > 0;
        });
      }, { threshold: 0 });
      beobachter.observe(anker);
    });
  }

  /* Vorher/Nachher-Regler (S05) */
  function schieber() {
    alle('[data-rb-schieber]').forEach(function (feld) {
      if (feld.getAttribute('data-rb-schieber-bereit') === 'ja') { return; }
      feld.setAttribute('data-rb-schieber-bereit', 'ja');
      var oben = feld.querySelector('.rb-pl-schieber__oben');
      var griff = feld.querySelector('.rb-pl-schieber__griff');
      var regler = document.getElementById(feld.getAttribute('data-rb-schieber'));
      if (!oben || !griff) { return; }

      function stelle(p) {
        p = Math.max(0, Math.min(100, p));
        oben.style.width = p + '%';
        griff.style.left = p + '%';
        if (regler && String(regler.value) !== String(Math.round(p))) { regler.value = Math.round(p); }
      }
      function ausPunkt(x) {
        var r = feld.getBoundingClientRect();
        stelle(((x - r.left) / r.width) * 100);
      }
      var zieht = false;
      feld.addEventListener('pointerdown', function (ev) {
        zieht = true;
        if (feld.setPointerCapture) { feld.setPointerCapture(ev.pointerId); }
        ausPunkt(ev.clientX);
      });
      feld.addEventListener('pointermove', function (ev) { if (zieht) { ausPunkt(ev.clientX); } });
      feld.addEventListener('pointerup', function () { zieht = false; });
      feld.addEventListener('pointercancel', function () { zieht = false; });
      if (regler) { regler.addEventListener('input', function () { stelle(Number(regler.value)); }); }
      stelle(50);
    });
  }

  /* Das Theme meldet einen Variantenwechsel NICHT per Event: es schreibt den
     neuen Wert direkt in das Attribut von form[action^="/cart/add"] input[name=id]
     (live geprüft 22.09.2026 — weder 'change' noch 'input' noch ein eigenes
     Ereignis wird ausgelöst). Deshalb hängen wir uns an genau dieses Attribut.
     Kein Intervall, kein Abfragen im Takt: der Beobachter schlägt nur an, wenn
     sich wirklich etwas ändert. */
  function anVariantenwechsel() {
    var feld = document.querySelector('form[action^="/cart/add"] input[name="id"]')
      || document.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (!feld || !window.MutationObserver) { return false; }
    new MutationObserver(function () { zeichne(); }).observe(feld, {
      attributes: true,
      attributeFilter: ['value']
    });
    return true;
  }

  function start() {
    zeichne();
    schieber();
    schwebeleiste();
    document.addEventListener('change', zeichne);
    document.addEventListener('click', klick);

    var gekoppelt = anVariantenwechsel();

    /* Rückfalltür, falls der Wähler ausgetauscht wird oder das Feld fehlt:
       nach einem Klick im Variantenwähler zweimal nachzeichnen, sobald das
       Theme fertig ist. Kosten nahe null, kein Dauerlauf. */
    document.addEventListener('click', function (ev) {
      if (!ev.target.closest) { return; }
      if (!ev.target.closest('.product-information-variant-picker, .product-information-variant-picker-button-variant-option, select.product-variant-select')) { return; }
      window.requestAnimationFrame(function () {
        zeichne();
        window.requestAnimationFrame(function () {
          zeichne();
          if (!gekoppelt) { gekoppelt = anVariantenwechsel(); }
        });
      });
    }, true);

    window.setTimeout(function () {
      zeichne();
      schwebeleiste();
      if (!gekoppelt) { anVariantenwechsel(); }
    }, 900);
  }

  window.RBPilzlicht = { zeichne: zeichne, setzeWert: setzeWert, aktuell: aktuell };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
}());
